import CONSTANTS from '~/constants'

export default ['$http', '$q', users]

function users($http, $q) {
  function fetchSettings(type) {
    var req = {
      method: 'GET',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/${type}`,
      timeout: 100000,
    }

    return $http(req)
  }

  function saveSettings(type, data) {
    if (typeof data._version === 'undefined') {
      data._version = 0
    }

    var req = {
      method: 'POST',
      data: JSON.stringify(data),
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/${type}`,
      timeout: 100000,
      headers: { 'Content-Type': 'application/json' },
    }

    return $http(req)
  }

  this.fetchAccess = function() {
    return fetchSettings('settings/access')
  }

  this.saveAccess = function(data) {
    return saveSettings('settings/access', data)
  }

  this.getAuthorization = function() {
    return fetchSettings('auth')
  }
}
